/* eslint-disable */
import { debounce } from "./helpers/debounce";

document.addEventListener("alpine:init", () => {

    Alpine.data("comparator", (props) => {
        return {
            bpDesktop: 1366,
            bzvcLoaded: false,
            showMore: false,
            isResized: false,
            removeDesktopHeight: [],
            removeMobileHeight: [],
            widthPerCol: 0,
            init () {           
                const debounceResize = debounce(() => {
                    if (this.ifMobile) this.$refs.stickyHeader.style.top = 0;

                    this.removeDesktopHeight = [];
                    this.removeMobileHeight = [];
                    this.showMore = false;
                    this.initFunc();
                    this.toggleContent();
                }, 100);

                this.windowEvents(debounceResize);
            },
            initFunc() {
                this.setNewColWidth();
                this.setTopSticky();
                setTimeout(() => this.getHideHeights(), 900);
            },
            windowEvents(debounceResize) {
                window.addEventListener("resize", debounceResize);
                window.addEventListener("scroll", () => this.setShadowHeader());
            },
            scrollToTop() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            removeZeroRating() {
                const _self = this.$el;
                const bzvcContent = _self.querySelectorAll(".comparator__detailInfo--bzvc");

                bzvcContent.forEach(el => {
                    const bzvc = el.querySelector(".bzvc");
                    const emptyRating = el.querySelector(".comparator__emptyRating");

                    if (!bzvc) {
                        emptyRating.classList.remove("hidden");
                        return;
                    }                        

                    const ratingEl = el.querySelector(".bv-off-screen").textContent;
                    const rating = ratingEl.split(" ")[0];
                    
                    if (rating === "0.0") {
                        bzvc.classList.add("hidden");
                        emptyRating.classList.remove("hidden");
                    }
                });
            },
            ifMobile() {
                let check = false;
                (function(a){
                    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            },
            getOffset(el) {
                const rect = el.getBoundingClientRect();
                return {
                  left: rect.left + window.scrollX,
                  top: rect.top + window.scrollY
                };
            },
            getStickyHeight() {
                const stickyHeader = document.querySelector("header[data-sticky='true']");
                const announcementBar = document.querySelector(".announcementBar.sticky");
                const announcementBarHeight = announcementBar? announcementBar.clientHeight : 0;

                return stickyHeader.offsetHeight + announcementBarHeight;
            },
            getLongest(items) {
                let longest = 0;
                
                items.forEach(item => {
                    const itemWidth = item.clientWidth;
                    longest = (itemWidth > longest)? itemWidth : longest;
                });
                
                return longest;
            },
            setNewColWidth() {
                const comparatorWrap = this.$root.querySelectorAll(".comparator__wrap");
                comparatorWrap.forEach(el => this.setCss(el, { width: `100%` }));

                if (!this.ifMobile()) return;

                const mainContainer = this.$root.querySelector(".comparator__main");
                const mainWidth = mainContainer.clientWidth;
                const items = this.$refs.stickyHeader.querySelectorAll(".comparator__products");
                const itemLen = items.length;
                const divideNum = itemLen > 2? 3 : itemLen;
                const containerWidth = mainWidth / divideNum;

                comparatorWrap.forEach(el => this.setCss(el, { width: `${containerWidth * itemLen}px` }));
            },
            setColWidth() {
                const container = this.$el.querySelectorAll(".comparator__container");

                container.forEach(el => {
                    el.style.minWidth = null;
                    el.style.maxWidth = null;
                });
                
                if (!this.ifMobile()) return;

                const itemLen = this.$refs.stickyHeader.querySelectorAll(".comparator__products").length;
                const divideNum = itemLen > 2? 3 : itemLen;

                setTimeout(() => {
                    const mainContainer = this.$el.querySelector(".comparator__main");
                    const mainContainerWidth = mainContainer.clientWidth;
                    this.widthPerCol = mainContainerWidth / divideNum;

                    container.forEach(el => {
                        el.style.minWidth = `${this.widthPerCol}px`;
                        el.style.maxWidth = `${this.widthPerCol}px`;
                    });

                    if (this.ifMobile()) this.setWidth();
                }, 100);
            },
            setShadowHeader() {                
                const stickyHeader = this.$refs.stickyHeader;
                const { top } = this.getOffset(stickyHeader);
                const stickyHeight = this.getStickyHeight();
                
                if (this.ifMobile()) return;

                const scrollY = window.scrollY + stickyHeight;

                this.setClassEvent({ el: stickyHeader, bool: scrollY >= top, className: "shadowBottom" });
            },
            setClassEvent({ el, bool, className}) {
                const classEvent = bool? "add" : "remove";
                el.classList[classEvent](className);
            },
            setCss(el, style) {
                Object.keys(style).forEach(key => {
                    el.style[key] = style[key];
                });
            },
            setWidth() { 
                const _self = this.$el;
                const wrap = _self.querySelectorAll(".comparator__wrap");

                const itemLen = this.$refs.stickyHeader.querySelectorAll(".comparator__products").length;
                const divideNum = itemLen > 2? 3 : itemLen;

                const mainContainer = this.$el.querySelector(".comparator__main");
                const mainContainerWidth = mainContainer.clientWidth;
                const containerWidth = mainContainerWidth / divideNum;
                const breakPoint = this.ifMobile();
                
                wrap.forEach(el => this.setCss(el, { width: breakPoint ? `${containerWidth * itemLen}px` : "100%" }));
            },
            setTopSticky() {
                window.addEventListener("scroll", () => {
                    const breakPoint = this.ifMobile();
                    const _self = this.$refs.stickyHeader;
                    let sumHeight = 0 ;

                    if (_self.classList.contains("sticky")) _self.style.top = sumHeight;

                    if (breakPoint) return;

                    const buttonSticky = document.querySelector(".buttonSticky--regular.sticky");
                    let buttonStickyrHeight = 0;

                    sumHeight = this.getStickyHeight();

                    if (_self.classList.contains("sticky")) _self.style.top = `${sumHeight}px`;

                    if (buttonSticky) {                 
                        if (breakPoint) return;

                        buttonStickyrHeight = buttonSticky.clientHeight;
                        const newSumHeight = sumHeight + buttonStickyrHeight;

                        if (_self.classList.contains("sticky")) _self.style.top = `${newSumHeight}px`;
                    }
                });
            },
            noBazaarVoiceWidth() {
                if (this.$refs.bzvc) return;

                let setWidth = 0;
                const _self = this.$el;
                const wrap = _self.querySelectorAll(".comparator__wrap");
                const stickyHeader = this.$refs.stickyHeader;
                const containers = stickyHeader.querySelectorAll(".comparator__container");
                
                containers.forEach(el => (setWidth += el.clientWidth));
                const breakPoint = this.ifMobile();

                wrap.forEach(el => this.setCss(el, { width: breakPoint ? `${setWidth}px` : "100%" }));
            },
            withBazaarVoiceWidth() {
                const bzvc = this.$refs.bzvc;

                if (!bzvc) {
                    this.bzvcLoaded = true;
                    return;
                }

                const bzvcEl = bzvc.querySelector(".bzvc");
                const config = { childList: true };

                const obs = new MutationObserver(mutationList => {
                    for (const mutation of mutationList) {
                        const [ childNode ] = mutation?.addedNodes;  

                        if (!this.bzvcLoaded) this.removeZeroRating();

                        this.bzvcLoaded = true;

                        setTimeout(() => this.setWidth(), 200);
                    }
                });
    
                obs.observe(bzvcEl, config);

                if (this.bzvcLoaded) this.setWidth();
            },
            getHideHeights() {
                this.$el.querySelectorAll(".row-hide").forEach(el => {
                    const desktopClass = el.classList.contains("showMoreContent--desktop");
                    if (el.scrollHeight !== 0) {
                        if (desktopClass) this.removeDesktopHeight.push(el.scrollHeight);
                        else this.removeMobileHeight.push(el.scrollHeight);
                    }
                });
            },
            toggleContent() {
                this.$root.querySelectorAll(".showMoreContent--desktop.row-hide").forEach((el, key) => {
                    this.setCss(el, {
                        height: this.showMore? `${this.removeDesktopHeight[key]}px` : 0,
                        opacity: this.showMore? 1 : 0
                    });
                });

                this.$root.querySelectorAll(".showMoreContent.row-hide").forEach((el, key) => {
                    this.setCss(el, {
                        height: this.showMore? `${this.removeMobileHeight[key]}px`: 0,
                        opacity: this.showMore? 1 : 0,
                    });

                    if (this.showMore) el.style.overflow = "unset";
                    else setTimeout(() => el.style.overflow = "hidden", 300);
                });
            },
            showMoreLess() { 
                this.showMore = !this.showMore;
                this.toggleContent();
            }
        };
    });

});